import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import GoldDivider from '../components/GoldDivider';

/**
 * Render a string that uses **bold** markers as React elements.
 * Splits on "**" and alternates between normal and bold segments.
 */
function renderMarkdown(text) {
  if (!text) return null;
  const paragraphs = text.split('\n\n').filter(Boolean);
  return paragraphs.map((para, pIdx) => {
    const parts = para.split('**');
    const children = parts.map((part, i) =>
      i % 2 === 1 ? (
        <strong key={i} style={{ color: 'var(--gold-light)' }}>
          {part}
        </strong>
      ) : (
        part
      )
    );
    return (
      <p
        key={pIdx}
        style={{
          marginBottom: '1.2rem',
          lineHeight: 1.8,
          color: 'var(--cream)',
        }}
      >
        {children}
      </p>
    );
  });
}

export default function Privacy() {
  const { t } = useLanguage();

  return (
    <div className="page-container" style={{ paddingTop: '2rem' }}>
      <h1 className="page-title">{t('privacy.title')}</h1>
      <GoldDivider />

      <div className="card" style={{ maxWidth: '720px', margin: '0 auto 2rem' }}>
        {renderMarkdown(t('privacy.content'))}
      </div>

      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <Link to="/" className="btn-secondary">
          {t('common.back')}
        </Link>
      </div>
    </div>
  );
}
